import React from 'react';

const formatNull = data => <>{String(data)}</>;

export default formatNull;
